import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkArchiveTypeItem, IDictionariesStore, IDictionariesActions } from '../types';

const onArchiveTypeItem: IThunkArchiveTypeItem = thunk(
  async ({ setTypeList }: Actions<IDictionariesActions>, payload, { getState }) => {
    const { type, id, clinicId } = payload;
    const localState = getState() as IDictionariesStore;

    await api.dictionaries.archiveTypeItem(type, id, clinicId);

    const updatedList = localState.list.map(item =>
      item.id !== payload.id ? item : { ...item, isArchived: true },
    );
    setTypeList({ items: updatedList });
  },
);

export default onArchiveTypeItem;
